
import Vue from 'vue';

import ResultsView from '@/pages/search/results/ResultsView.vue';

import * as InterfaceStore from '@/store/search/form/interface';
import * as UIStore from '@/store/search/ui';
import * as ViewStore from '@/store/search/results/views';

export default Vue.extend({
	components: {
		ResultsView,
	},
	methods: {
		showView(id: string) {
			InterfaceStore.actions.viewedResults(id);
		},
		storeFor(id: string) {
			return ViewStore.getOrCreateModule(id);
		}
	},
	computed: {
		viewedResults: InterfaceStore.get.viewedResults,
		customViews(): UIStore.CustomView[] {
			return UIStore.getState().results.customViews;
		}
	}
});
